export default __webpack_public_path__ + "static/media/Ellipse (3).d379c57a.svg";